$(document).ready(function Investments() {
	var filterData = {};
	var lastFilterData = {};
	var $investments = $('.investment-block__content');
	var $investmentsJq = [];
	var $intestmentsContainerJq = [];
	var $noResults = $('.investments__no-result');
	
	var initMap = function() {
		var prepareMap = function($container) {
			var point;
			var center;
			var map;
			var marker;
			var infowindow;
			
			point = {lat: parseFloat($container.data('latitude')), lng: parseFloat($container.data('longitude'))};
			
			center = {
				lat: point.lat,
				lng: point.lng
			};
			center.lat += 0.003;
			
			map = new google.maps.Map($container.get(0), {
			    center: center,
			    zoom: 13,
			    disableDefaultUI: true,
			    zoomControl: true,
			    zoomControlOptions: {
			        position: google.maps.ControlPosition.RIGHT_CENTER
			    },
		    });
			
			marker = new google.maps.Marker({
				position: point,
				map: map,
				title: $container.data('name')
			});
			
			infowindow = new google.maps.InfoWindow({
				content: '<b>'+$container.data('name')+'</b>'
			});
			
			infowindow.open(map, marker);
			
			$container.click(function() {
//				return false;
			})
			
			$container.data('map', {
				recenter: function() {
					map.setCenter(center)
				}
			});
		};
		
		$('.investment-block__map-btn').click(function() {
			var $this = $(this);
			var $map = $this.data('map');
			if(!$map) {
				$map = $this.parents('.investment-block').find('.investment-block__map');
				$this.data('map', $map);
				prepareMap($map);
			}
			
			if($map.length > 0) {
				if(!$this.data('mapVisible')) {
					$map.addClass('investment-block__map--visible');
					$this.data('mapVisible', true);
					$this.addClass('investment-block__map-btn--active');
					$map.data('map').recenter();  
				} else {
					$map.removeClass('investment-block__map--visible');
					$this.data('mapVisible', false);
					$this.removeClass('investment-block__map-btn--active');
				}
			}
			
			return false;
		});
	};
	
	var initSliders = function() {
		var $sliders = $('.investments-filters .filter-slider');
		runSliders($sliders, filterData, filter);
	};
	
	var initSelects = function() {
		var $containers = $('.investments-filters .filter-select');
		var $container;
		var $select;
		for(var i = 0, s = $containers.length; i < s; i++) {
			$container = $($containers[i]);
			$select = $container.find('select');
			$select.change(function(name, event) {
				var val = this.val();
				if(val === '') {
					delete(filterData[name]);
				} else {
					filterData[name] = val;
				}
				filter();
			}.bind($select, $container.data('name')));
		}
	};
	
	var filterDataToQuery = function(filterData) {
		var out = [];
		if(filterData.pricePerMeter) {
			out.push('<pricePerMeter>='+filterData.pricePerMeter.from+':'+filterData.pricePerMeter.to);
		}
		
		if(filterData.area) {
			out.push('<area>='+filterData.area.from+':'+filterData.area.to);
		}
		
		if(filterData.roomsNumber) {
			out.push('<roomsNumber>='+filterData.roomsNumber.from+':'+filterData.roomsNumber.to);
		}
		
		if(filterData.localization) {
			out.push('localization='+filterData.localization);
		}
		
		if(filterData.type) {
			out.push('type='+filterData.type);
		}
		
		if(filterData.status) {
			out.push('status='+filterData.status);
		}
		
		return out.join(',');
	};
	
	var hide = function($block) {
		var $parent = $block.parent();
		var callback = function(callback) {
			this.hide();
		};
		if(false === $parent.hasClass('investment-block--hidden')) {
			onAnimationEnd($parent, callback.bind($parent, callback));
			$parent.addClass('investment-block--hidden');
		}
	};
	
	var show = function($block) {
		var $parent = $block.parent();
		if(true === $parent.hasClass('investment-block--hidden')) {
			$parent.show();
			$parent.removeClass('investment-block--hidden');
		}
	};
	
	var showAll = function() {
		for(var i = 0, s = $investments.length; i < s; ++i) {
			if(!$investmentsJq[i]) {
				$investmentsJq[i] = $($investments[i]);
			}
			show($investmentsJq[i]);
		}
	};
	
	var filter = function() {
		$.get({
			url: _BASE_URL+'/inwestycje/filtruj',
			data: {
				query: filterDataToQuery(filterData)
			}
		})
		.then(function(uuids) {
			console.log(uuids);
			var $block;
			var uuid;
			for(var i = 0, s = $investments.length; i < s; ++i) {
				if(!$investmentsJq[i]) {
					$investmentsJq[i] = $($investments[i]);
				}
				$block = $investmentsJq[i];
				uuid = $block.data('uuid');
				if(uuids.indexOf(uuid) === -1) {
					hide($block);
				} else {
					show($block);
				}
			}
			if(uuids.length === 0) {
				if($noResults.hasClass('alert--hidden')) {
					$noResults.hide();
					$noResults.removeClass('alert--hidden');
				}
				$noResults.slideDown();
			} else {
				$noResults.slideUp();
			}
		})
		.catch(function() {
			showAll();;
		});
	};
	
	
	initMap();
	initSliders();
	initSelects();
	
	
});